import React, { useEffect, useRef } from "react";
import { columnChart, registerTheme } from "tui-chart";
import "tui-chart/dist/tui-chart.css";

const theme = {
  title: { color: "#8791af" },
  xAxis: { label: { color: "#8791af" }, tickColor: "#8791af" },
  yAxis: { label: { color: "#8791af" }, tickColor: "#8791af" },
  legend: { label: { color: "#8791af" } },
};

registerTheme("myTheme", theme);

function ColumnChart({ categories, series, title }) {
  const chartRef = useRef(null);

  useEffect(() => {
    const container = chartRef.current;
    if (!container) return;

    const data = { categories, series };

    const options = {
      chart: { width: container.offsetWidth, height: 305, title },
      yAxis: { title: "Amount", min: 0, max: 9000 },
      xAxis: { title: "Month" },
      legend: { align: "top" },
      theme: "myTheme",
    };

    const chart = columnChart(container, data, options);

    const handleResize = () => {
      chart.resize({ width: container.offsetWidth, height: 305 });
    };
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
      chart.destroy();
    };
  }, [categories, series, title]);

  return <div ref={chartRef} style={{ width: "100%" }} />;
}

export default ColumnChart;